define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/arr.js
// module id = 20
// module chunks = 0